/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type GoalDetailsReviewTab_goal = {
    readonly archived: boolean | null;
    readonly nextReviewAt: string;
    readonly " $refType": "GoalDetailsReviewTab_goal";
};
export type GoalDetailsReviewTab_goal$data = GoalDetailsReviewTab_goal;
export type GoalDetailsReviewTab_goal$key = {
    readonly " $data"?: GoalDetailsReviewTab_goal$data;
    readonly " $fragmentRefs": FragmentRefs<"GoalDetailsReviewTab_goal">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "GoalDetailsReviewTab_goal",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "archived",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "nextReviewAt",
      "storageKey": null
    }
  ],
  "type": "Goal",
  "abstractKey": null
};
(node as any).hash = '73c754e87d20228b75b0d599386c2420';
export default node;
